'use client';
import type { PropsWithChildren } from 'react';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import BridgeProvider from '@/providers/BridgeProvider';
import { theme } from '@/utils/theme';
import { useMountEffect } from '@/hooks/useMountEffect';
import ReduxProvider from '../ReduxProvider';
import SocketsProvider from '../SocketsProvider';
import AppStateProvider from '../AppStateProvider';
import LoadedFilesProvider from '../LoadedFilesProvider';
import FaceLandmarksProvider from '../FaceLandmarksProvider';

export default function AppProviders({ children }: PropsWithChildren) {
  // NOTE: Need to wrap in useEffect otherwise `window` is undefined due to Next.js pre-rendering
  useMountEffect(() => {
    if (getEnv() !== NODE_ENV.PRODUCTION) window.muiTheme = theme;
  });

  return (
    <ReduxProvider>
      <SocketsProvider>
        <AppStateProvider>
          <BridgeProvider>
            <LoadedFilesProvider>
              <FaceLandmarksProvider>{children}</FaceLandmarksProvider>
            </LoadedFilesProvider>
          </BridgeProvider>
        </AppStateProvider>
      </SocketsProvider>
    </ReduxProvider>
  );
}
